jQuery_T4NT(document).ready(function($) {


  $(".gpo-container .personalization-header").click(function() {
      // 切换 .active 类
      $(this).toggleClass("active");
      $(".personalization-ele").toggle();
    });

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
         $sizeOption = evt.currentVariant.option2;
	     if($sizeOption == 'Custom Size') {
           $('.gpo-container .custom-size').show();
            $('.custom-size-imgtip').show();
         } else {
           $('.gpo-container .custom-size').hide();
            $('.custom-size-imgtip').hide();
         }
         $variantInventory = evt.currentVariant.inventory_quantity;
         var currentDate = new Date();
         // 计算开始时间和结束时间
         var startDate, endDate, expeditedStartDate, expeditedEndDate;
         if($variantInventory > 0) {
           startDate = new Date(currentDate);
           endDate = new Date(currentDate);
           startDate.setDate(currentDate.getDate() + 12);
           endDate.setDate(currentDate.getDate() + 14);
           expeditedStartDate.setDate(currentDate.getDate() + 9);
           expeditedEndDate.setDate(currentDate.getDate() + 10);
           $('#tailoring-time').text('Ship in 72hrs');
           // $('#tailoring-time').text('Tailoring Time: 10-13 Days')
         } else{
           startDate = new Date(currentDate);
           endDate = new Date(currentDate);
           startDate.setDate(currentDate.getDate() + 14);
           endDate.setDate(currentDate.getDate() + 16);
           expeditedStartDate.setDate(currentDate.getDate() + 12);
           expeditedEndDate.setDate(currentDate.getDate() + 13);
           // $('#tailoring-time').text('Tailoring Time: 6-8 Days');
         }
         var options = {month: 'short', day: 'numeric' };
         var startDateString = startDate.toLocaleDateString('en-US', options);
         var endDateString = endDate.toLocaleDateString('en-US', options);
         var expeditedStartDateString = expeditedStartDate.toLocaleDateString('en-US', options);
         var expeditedEndDateString = expeditedEndDate.toLocaleDateString('en-US', options);
         // 显示最终的交货时间范围
          var deliveryMessage = "<i class='las la-truck'></i>Standard : Order today, get it <span class='start-date'>" + startDateString + "</span> - <span class='end-date'>" + endDateString + "</span>";
         var expeditedDeliveryMessage = "<i class='las la-shipping-fast'></i>Expedited : Order today, get it <span class='start-date'>" + expeditedStartDateString + "</span> - <span class='end-date'>" + expeditedEndDateString + "</span>"; 
         $("#delivery-info").html(expeditedDeliveryMessage + "</br>" + deliveryMessage);
	   });

       $currentSize = $('.is-t4s-name__size .t4s-swatch__item.is--selected').attr('data-value');
       $hasStock =  $('#tailoring-time').attr('data-has-stock');
       var currentDate = new Date();
       var startDate, endDate, expeditedStartDate, expeditedEndDate;
       if($currentSize == 'Custom Size') {
         $('.gpo-container .custom-size').show();
         $('.custom-size-imgtip').show();
       }
       if($hasStock == 1) {
           startDate = new Date(currentDate);
           endDate = new Date(currentDate);
           expeditedStartDate = new Date(currentDate);
           expeditedEndDate = new Date(currentDate);
           startDate.setDate(currentDate.getDate() + 12);
           endDate.setDate(currentDate.getDate() + 14);
           expeditedStartDate.setDate(currentDate.getDate() + 9);
           expeditedEndDate.setDate(currentDate.getDate() + 10);
       } else {
           startDate = new Date(currentDate);
           endDate = new Date(currentDate);
           expeditedStartDate = new Date(currentDate);
           expeditedEndDate = new Date(currentDate);
           startDate.setDate(currentDate.getDate() + 14);
           endDate.setDate(currentDate.getDate() + 18);
           expeditedStartDate.setDate(currentDate.getDate() + 12);
           expeditedEndDate.setDate(currentDate.getDate() + 14);
       }
       var options = { month: 'short', day: 'numeric' };
       var startDateString = startDate.toLocaleDateString('en-US', options);
       var endDateString = endDate.toLocaleDateString('en-US', options);
       var expeditedStartDateString = expeditedStartDate.toLocaleDateString('en-US', options);
      var expeditedEndDateString = expeditedEndDate.toLocaleDateString('en-US', options);
       // 显示最终的交货时间范围
        var deliveryMessage = "<i class='las la-truck'></i>Standard : Order today, get it <span class='start-date'>" + startDateString + "</span> - <span class='end-date'>" + endDateString + "</span>";
         var expeditedDeliveryMessage = "<i class='las la-shipping-fast'></i>Expedited : Order today, get it <span class='start-date'>" + expeditedStartDateString + "</span> - <span class='end-date'>" + expeditedEndDateString + "</span>"; 
         $("#delivery-info").html(expeditedDeliveryMessage + "</br>" + deliveryMessage);
     

});